import React from 'react';
import { useDispatch } from 'react-redux';
import { ListItem, ListItemAvatar, Avatar, ListItemText } from '@mui/material';
import { AlertExtend } from '../types/store/storeTypes';
import { markAlertAsRead } from 'src/store/apps/alert'
import { AppDispatch } from 'src/store'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

interface AlertProps {
    alert: AlertExtend;
}

const SingleAlert: React.FC<AlertProps> = ({ alert }) => {
    const dispatch = useDispatch<AppDispatch>();

    const markAlertStatus = (alertId: string) => {
        dispatch(markAlertAsRead({ alertId: alertId }));
    }

    const getAvatar = (alert: AlertExtend) => {
        return alert.picture ? <Avatar src={alert.picture} alt='' /> : <Avatar alt='' > {alert.userInitials}</Avatar>
    }

    return (
            <ListItem
                onClick={() => markAlertStatus(alert.alertGuid)}
            >
                    <ListItemAvatar>
                    {getAvatar(alert)}
                    </ListItemAvatar>
                    <div>
                        <ListItemText primary={alert.title} />
                        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                            <Box sx={{ mr: 3, display: 'flex', alignItems: 'center', '& svg': { mr: 1, color: 'warning.main' } }}>
                                <Typography variant='caption'>{alert.message}</Typography>
                            </Box>
                            <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                {alert.createdDateString}
                            </Typography>
                        </Box>
                    </div>
                    {/*<ListItemSecondaryAction>*/}
                    {/*    <Button variant='contained' size='small'>*/}
                    {/*        Add*/}
                    {/*    </Button>*/}
                    {/*</ListItemSecondaryAction>*/}
                </ListItem>
    );
};

export default SingleAlert;
